module.exports = __webpack_public_path__ + "img/taiwan,-province-of-china.cb641673.svg";